import { render, staticRenderFns } from "./ProteinPTMview.vue?vue&type=template&id=35ee6138&scoped=true"
import script from "./ProteinPTMview.vue?vue&type=script&lang=js"
export * from "./ProteinPTMview.vue?vue&type=script&lang=js"
import style0 from "./ProteinPTMview.vue?vue&type=style&index=0&id=35ee6138&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ee6138",
  null
  
)

export default component.exports